import { DEBUG } from '../logLevels';

export class Interceptor {
    constructor({ entity, enrichments, minimalLevel, level, force }) {
        this.enrichments = enrichments;
        this.entity = entity;
        this.minimalLevel = minimalLevel;
        this.level = level;
        this.force = force;
        this.blocked = false;
    }

    mute() {
        this.level = DEBUG;
    }

    block() {
        this.blocked = true;
    }

    enrich(data = {}) {
        Object.assign(
            this.enrichments,
            data
        );
    }
}

export class Interceptors {
    constructor() {
        this.interceptors = [];
    }

    add(interceptor) {
        if (typeof interceptor !== 'function') {
            return;
        }

        this.interceptors.unshift(interceptor);
    }

    run({ entity, enrichments, minimalLevel, level, force }) {
        const interceptor = new Interceptor({
            entity, enrichments, minimalLevel, level, force
        });

        for (const hook of this.interceptors) {
            hook(interceptor);
        }

        return interceptor;
    }
}
